;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import ShowRow from "@/components/ShowRow/ShowRow";
import { ShowRowContent } from "@/lib/types/api/show-data";

import type { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

interface FeaturedShowsRowProps {
  shows: ShowRowContent[];
  showBadgeFlags?: ShowBadgeFlags;
}

const FeaturedShowsRow = (props: FeaturedShowsRowProps) => {
  const { shows, showBadgeFlags } = props;

  return (
    <ShowRow
      shows={shows}
      title={'Featured Shows'}
      showBadgeFlags={showBadgeFlags}
    data-sentry-element="ShowRow" data-sentry-component="FeaturedShowsRow" data-sentry-source-file="FeaturedShowsRow.tsx" />
  )
}

export default FeaturedShowsRow;
